import { ReactElement, useEffect, useState } from 'react'
import { Link } from "react-router-dom"
import { Menu, Layout } from 'antd'
import { UserOutlined } from '@ant-design/icons'

const { Sider } = Layout
const { SubMenu } = Menu

/**
 * 默认展开第一个栏目和给第一栏目下的第一个链接加高亮，随着topIndex改变
 */
type Props = {
  sideMenuData: any[]
  topIndex: String
  sideOpenKeys: string
  sideSelectedKeys: string
  topMenuData: any[]

  handleSideMenuClick: ({ key }: { key: any }) => void
  handleSideSubMenuClick: ({ key }: { key: any }) => void
}

export default function SideMenu(props: Props) {

  const [MatchMenuElemnt, setMatchMenuElemnt] = useState<any[]>()
  let { sideMenuData, topMenuData, topIndex } = props

  useEffect(() => {
    if (sideMenuData.length && topMenuData.length) {
      let menuArr: any = []

      sideMenuData.forEach((el: any) => {
        if (el.p_id === topMenuData[Number(topIndex)].id) {
          let ItemList: ReactElement[] = el.children.map((el2: any) => (<Menu.Item key={el2.id} onClick={props.handleSideMenuClick}><Link to={el2.route_url}>{el2.name}</Link></Menu.Item>))
          menuArr.push(<SubMenu key={el.id} icon={<UserOutlined />} title={el.name}
            onTitleClick={props.handleSideSubMenuClick} >{ItemList}</SubMenu>)

          setMatchMenuElemnt(menuArr)
        }
      })

    }
  }, [props])

  return <Sider width={200} className="site-layout-background">
    <Menu
      mode="inline"
      openKeys={[`${props.sideOpenKeys}`]}
      selectedKeys={[`${props.sideSelectedKeys}`]}
      style={{ height: '100%', borderRight: 0 }}
    >
      {MatchMenuElemnt}
    </Menu>
  </Sider>
}